import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateSolicitudGastosContingenciaProfesionalItByID = () => {
  const [loadingUpdateSolicitudGastosContingenciaProfesionalById, setLoadingCreateSolicitudGastosContingenciaProfesional] = useState(false);
  const [successUpdateSolicitudGastosContingenciaProfesionalById, setSuccessCreateSolicitudGastosContingenciaProfesional] = useState(false);
  const [errorUpdateSolicitudGastosContingenciaProfesionalById, setErrorCreateSolicitudGastosContingenciaProfesional] = useState(null);
  const [dataUpdateSolicitudGastosContingenciaProfesionalById, setDataSolicitudGastosContingenciaProfesional] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateSolicitudGastosContingenciaProfesionalById = async (userId:string ,prestacionId: string, formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudGastosContingenciaProfesional(true);
    setSuccessCreateSolicitudGastosContingenciaProfesional(false);
    setErrorCreateSolicitudGastosContingenciaProfesional(null);

    apiRecord.updateSolicitudGastosContingenciaProfesionalItByID(userId, formId, data).then((res: any) => {
      setLoadingCreateSolicitudGastosContingenciaProfesional(false);
      setSuccessCreateSolicitudGastosContingenciaProfesional(true);
      setDataSolicitudGastosContingenciaProfesional(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudGastosContingenciaProfesional(false);
      setErrorCreateSolicitudGastosContingenciaProfesional(err.response.data)
    })
  }

  return {
    updateSolicitudGastosContingenciaProfesionalById,
    loadingUpdateSolicitudGastosContingenciaProfesionalById,
    successUpdateSolicitudGastosContingenciaProfesionalById,
    errorUpdateSolicitudGastosContingenciaProfesionalById,
    dataUpdateSolicitudGastosContingenciaProfesionalById
  }

}

export default useUpdateSolicitudGastosContingenciaProfesionalItByID;
